import React from 'react';
import { useSelector } from '~/redux';
import { Link } from 'react-router-dom';

import { styled } from '~/styles';
import AttendeesLink from '~/components/links/AttendeesLink';
import LogOutLink from '~/components/links/LogOutLink';
import ProfileLink from '~/components/links/ProfileLink';
import ReferralLink from '~/components/links/ReferralLink';
import UsernameWithAvatar from '~/components/links/UsernameWithAvatar';


const StyledDropdown = styled.ul`
  > li {
    position: relative;

    > a {
      display: flex;
      align-items: center;
      white-space: nowrap;
      cursor: pointer;
      width: calc(100% + 20px);

      img {
        width: 24px;
        height: auto;
        margin-right: 4px;
      }
    }

    > ul {
      right: -20px;
      left: auto;
      width: calc(100% + 20px);
    }
  }

  &.no-user-data {
    white-space: nowrap;
  }
`

function UserDropdown() {
  // redux state
  const user = useSelector((state) => state.user);

  return /* (user !== null && user.confirmed) ? ( */ (
    <StyledDropdown>
      <li>
        <UsernameWithAvatar />

        <ul>
          {/* <li>
            <ProfileLink />
          </li> */}
          {/* <li className='collapse-only'>
            <AttendeesLink />
          </li> */}
          {/* <li className='collapse-only'>
            <ReferralLink />
          </li> */}
          <li>
            <LogOutLink as='a' />
          </li>
        </ul>
      </li>
    </StyledDropdown>
  /* ) : 
    <StyledDropdown className='no-user-data'>
      <li>
        <LogOutLink as='a' />
      </li>
    </StyledDropdown>
  */
  );
}

export default UserDropdown;



// WEBPACK FOOTER //
// ./src/components/layout/header/UserDropdown.tsx